import { WIDGET_ICON_BACKGROUND_TYPE } from '../../rss-feed-widget/constants/wix-params';
import { BACKGROUND_TYPE_SQUARE } from '../../rss-feed-widget/constants/backgrounds';


export const getBackgroundTypeId = ({ style = {} } = {}) =>
  style.numbers ? style.numbers[WIDGET_ICON_BACKGROUND_TYPE] || BACKGROUND_TYPE_SQUARE : BACKGROUND_TYPE_SQUARE;




// WEBPACK FOOTER //
// ./rss-feed-widget-settings/selectors/app-settings-selectors.js